import { Component, inject, Input } from '@angular/core';
import { ActionCardConfigInterface, BrightsideUiModule } from '@brightside/brightside-ui';
import {
  ServiceNotificationIcon,
  ServiceNotificationItem
} from '@brightside-web/desktop/feature/service-notifications';
import { TranslateService } from '@ngx-translate/core';
import { getRouteForKey } from '@brightside-web/desktop/data-access/core-services';
import { Router } from '@angular/router';
import { FirebaseService } from '@brightside-web/desktop/data-access/shared';


@Component({
    selector: 'brightside-web-alert-action',
    imports: [BrightsideUiModule],
    templateUrl: './alert-action.component.html',
    styleUrl: './alert-action.component.css'
})
export class AlertActionComponent {

  @Input() notificationItem: ServiceNotificationItem;
  actionCardConfig: ActionCardConfigInterface;

  private _translateSvc = inject(TranslateService);
  private _router = inject(Router);
  private _analytics = inject(FirebaseService);

  constructor() { }

  ngOnInit() {
    this.actionCardConfig = this.mapToActionCardConfig(this.notificationItem);
  }

  mapToActionCardConfig(
    item: ServiceNotificationItem
  ): ActionCardConfigInterface {
    return {
      label: this._translateSvc.instant(item.copy1),
      title: this._translateSvc.instant(item.copy2),
      body: this._translateSvc.instant(item.copy3),
      labelIcon: ServiceNotificationIcon[item.state] ?? '',
      cardStyle: 'small',
      shadow: !item.read,
      bgColor: item.read ? '#e6e6e6' : 'white'
    };
  }

  navigate() {
    if (this.notificationItem.key) {
      const route = getRouteForKey({ key: this.notificationItem.key, route: this.notificationItem.route });
      this._analytics.logEvent('notifications tapped', {type: this.notificationItem.key, url: this.notificationItem.route })
      this._router.navigate([route]);
    }
  }
}
